import { Typography } from '@mui/material';
import PropTypes from 'prop-types';

import {
  getCurrentPolicy,
  getLatestActivePlan,
  getLatestPlan,
} from '../../../../shared/utils/productUtils';
import { customerDetailStyle } from '../customer-detail/customer-detail-styles';

function PlanStatusField({ petRecord }) {
  const classes = customerDetailStyle();

  const policy = getCurrentPolicy(petRecord?.policies);

  const latestActivePlan = getLatestActivePlan(policy, petRecord);
  const plan = latestActivePlan || getLatestPlan(policy, petRecord);

  return plan ? (
    <Typography
      variant='subtitle2'
      sx={{ color: '#000000', textTransform: 'capitalize' }}
      className={plan?.status === 'cancelled' ? classes.cancelledStatus : null}
    >
      {plan.status}
    </Typography>
  ) : (
    ''
  );
}

PlanStatusField.propTypes = {
  petRecord: PropTypes.shape({
    policies: PropTypes.arrayOf(
      PropTypes.shape({
        status: PropTypes.string,
      })
    ),
  }),
};

export default PlanStatusField;
